<div
  [contextMenuTrigger]="menu"
  [menuContext]="{ value: driverservice.formsetting, enum: contextmenuEnum.Category, visible: true }"
  (menuAction)="($event)"
  class="page">
  <div class="header">
    <div class="factorstate">
      <div
        (click)="driverservice.changeInvoiceBystatus(false); driverservice.showFleetMap = false; driverservice.showNotification = false"
        [class.active]="!driverservice.showFleetMap && !driverservice.showNotification && !this.driverservice.isShowAssignInvoice"
        class="sent">
        <i class="factorstateicon icon-text-box-outline"></i>
        <span class="">{{ "ClientApp.FrontOffice.DriverAssignment.UnsentInvoices" | translate }}</span>
      </div>
      <div
        (click)="driverservice.changeInvoiceBystatus(true); driverservice.showFleetMap = false; driverservice.showNotification = false"
        [class.active]="!driverservice.showFleetMap && !driverservice.showNotification && this.driverservice.isShowAssignInvoice"
        class="unsent">
        <i class="factorstateicon icon-text-box-check-outline"></i>
        <span class="">{{ "ClientApp.FrontOffice.DriverAssignment.SentInvoices" | translate }}</span>
      </div>
      <ng-container *ngIf="driverservice.hasCourierFleet">
        <div (click)="onMapClick(); driverservice.showNotification = false" [class.active]="driverservice.showFleetMap" class="fleet">
          <i class="factorstateicon icon-map-marker-radius"></i>
          <span>{{ "ClientApp.FrontOffice.DriverAssignment.FleetMap" | translate }}</span>
        </div>
        <div (click)="onNotificationClick()" [class.active]="driverservice.showNotification" class="fleet">
          <small [class.d-none]="!this.driverservice.newNotificationCount">{{ this.driverservice.newNotificationCount }}</small>
          <i class="factorstateicon icon-notifications_active-F"></i>
          <span>{{ "ClientApp.FrontOffice.DriverAssignment.Notification" | translate }}</span>
        </div>
      </ng-container>
    </div>
    <div class="factorsearch">
      <ssg-select
        *ngIf="driverservice.deliverySaleMethodData.length > 1"
        name="SaleMethodBranchIds"
        [group]="driverservice.formGroup"
        class="SaleMethod"
        [label]="'ClientApp.FrontOffice.DriverAssignment.SaleMethods' | translate"
        textFieldName="SaleMethodTitle"
        [dataList]="driverservice.deliverySaleMethodData"
        valueFieldName="Id"
        [multiple]="true"
        (valueChange)="driverservice.saleMethodBranchChanges($event)">
      </ssg-select>
      <ssg-input
        [name]="driverservice.inputSearch"
        [label]="'ClientApp.FrontOffice.DriverAssignment.Search' | translate"
        [group]="driverservice.formGroup"
        required="false"
        textType="text"
        [disabled]="false">
      </ssg-input>
    </div>
  </div>
  <div class="main" *ngIf="!driverservice.showFleetMap">
    <div class="factors" *ngIf="!driverservice.showNotification">
      <div class="factorheader">
        <div class="headerbox">
          <div class="factorstatus" *ngFor="let item of driverservice.invoiceFilter">
            <button
              class="factorprepare"
              [ngClass]="{ statusClickedBg: item.selected > 0 }"
              (click)="driverservice.selectedInvoice(item); driverservice.invoiceFilterByStatus()">
              <div class="status" [ngClass]="{ gray: item.key === 0, orange: item.key === 1, red: item.key === 2 }">
                <div class="statusicon"></div>
                <div>
                  <span class="statustext">{{ item.title }}</span>
                  <span class="statustext">{{ item.count }}</span>
                </div>
              </div>
            </button>
          </div>
        </div>
        <div class="factorBarcode">
          <ssg-input
            (onEnter)="driverservice.barCodeFinder($event)"
            [name]="driverservice.inputBarCode"
            [label]="'ClientApp.FrontOffice.DriverAssignment.BarCode' | translate"
            [group]="driverservice.formGroup"
            required="false"
            textType="text"
            [disabled]="false">
          </ssg-input>
        </div>
        <date-picker
          id="dpDrvierAssignmentDate"
          name="drvierAssignmentDate"
          class="drvierAssignmentDate"
          [group]="driverservice.formGroup"
          (valueChange)="driverservice.GetAllInvoicesByDate($event)"
          [label]="'ClientApp.FrontOffice.DriverAssignment.Date' | translate"
          required="false"
          textType="date"
          disabled="false"
          class="datealighn">
        </date-picker>
      </div>
      <div class="factorcards">
        <div
          *ngFor="
            let invoice of driverservice.currentInvoices
              | filter
                : {
                    Driver: driverservice.formGroup.controls[driverservice.inputSearch].value,
                    NumberingInDate: driverservice.formGroup.controls[driverservice.inputSearch].value,
                    DriverId: driverservice.formGroup.controls[driverservice.inputSearch].value,
                    CustomerName: driverservice.formGroup.controls[driverservice.inputSearch].value,
                    CustomerNumber: driverservice.formGroup.controls[driverservice.inputSearch].value,
                    PayableTotal: driverservice.formGroup.controls[driverservice.inputSearch].value,
                    CustomerLastName: driverservice.formGroup.controls[driverservice.inputSearch].value
                  };
            let index = index
          "
          class="factorcarddetail select"
          [class.selected]="invoice.Selected > 0"
          (click)="driverservice.selectedInvoice(invoice)">
          <div class="factorcardnumber">
            <div class="factorprice d-flex">
              <i
                class="factor-card-icon icon-fiber_manual_record-f"
                [ngClass]="{
                  gray: invoice.DriverAssignmentStatus === driverservice.driverAssignmentStatus.Preparing,
                  orange: invoice.DriverAssignmentStatus === driverservice.driverAssignmentStatus.DelayInPreparation,
                  red: invoice.DriverAssignmentStatus === driverservice.driverAssignmentStatus.ExcessivePreparationDelay
                }"></i>
              <span class="factornumber">{{ "ClientApp.FrontOffice.DriverAssignment.Factor" | translate }} {{ invoice.NumberingInDate }} </span>
              <span>- {{ invoice.PayableTotal | number }} {{ "ClientApp.FrontOffice.DriverAssignment.UnitPrice" | translate }}</span>
            </div>
            <div class="factorname">
              <i class="drivericon icon-person_outline-F"></i>
              <span>{{ invoice.CustomerDisplayName }}</span>
            </div>
          </div>
          <div class="factortime">
            <div class="factortimeicon">
              <i class="drivericon icon-watch_later-o"></i>
              <span class="factortimepast"
                >{{ invoice.FactorStringTime }} {{ "ClientApp.FrontOffice.DriverAssignment.FactorTimePast" | translate }}
              </span>
            </div>
            <div class="factorassigntime" *ngIf="driverservice.isShowAssignInvoice">
              <span>{{ "ClientApp.FrontOffice.DriverAssignment.SentTime" | translate }}{{ invoice.DriverAssingDate }}</span>
            </div>
          </div>
          <div class="factorassigntime return-time" *ngIf="driverservice.isShowAssignInvoice">
            <span>{{ "ClientApp.FrontOffice.DriverAssignment.TimeBack" | translate }} {{ invoice.ShamsiDriverReturnDate }}</span>
          </div>
          <div class="factoraddress" [ngClass]="{ 'pickup-flag': invoice.IsPickUp }">
            <i class="drivericon icon-pin_drop-F"></i>
            <span> {{ invoice.IsPickUp ? ("ClientApp.FrontOffice.DriverAssignment.InPersonDelivery" | translate) : invoice.Address }}</span>
          </div>
          <div class="cheack" [class.displaycheck]="!invoice.Selected">
            <i class="drivericoncheck icon-check-o"></i>
          </div>
          <div
            *ngIf="driverservice.isShowAssignInvoice && invoice.StatusCode !== driverservice.invoicestatus.Completed"
            class="cancel-assign"
            (click)="driverservice.CancelAssignment(invoice)">
            <i class="icon-account-arrow-right"></i>
            <span>{{ "ClientApp.FrontOffice.DriverAssignment.CancelAssignment" | translate }} {{ invoice.DisplayName }}</span>
          </div>
          <div *ngIf="driverservice.isShowAssignInvoice && invoice.StatusCode === driverservice.invoicestatus.Completed" class="exitdriver">
            <i class="drivericon icon-person_outline-F"></i>
            {{ "ClientApp.FrontOffice.DriverAssignment.Driver" | translate }}: {{ invoice.DisplayName }}
          </div>
        </div>
      </div>
    </div>

    <div class="drivers" *ngIf="!driverservice.showNotification">
      <div class="driverstatus">
        <button
          class="driverpresent"
          *ngFor="let item of driverservice.DriverFilter"
          [class.selected-event]="item.key === driverservice.currentDriverFilter"
          (click)="driverservice.driverFilterByStatus(item.key)">
          <div class="peyk-event">
            <span class="statustext">{{ item.title }} </span>
            <span class="peyk-count">{{ item.count }}</span>
          </div>
        </button>
      </div>
      <div class="drivercard">
        <div
          class="drivercardinfo"
          [class.selected]="driver === this.driverservice.selectedDriver && driverservice.isShowAssignInvoice"
          *ngFor="let driver of driverservice.currentDrivers"
          (click)="driverservice.selectedDrive(driver)">
          <div class="driverinfo">
            <div class="drivernumber">
              <i class="drivericon icon-qr_code_2-o"></i>
              <span>{{ driver.Number }}</span>
            </div>
            <div class="driverpayment">
              <span *ngIf="driver.AssignmentInvoicesTotal > 0">
                {{ driver.AssignmentInvoicesTotal | number }}
              </span>
              <div class="sumbox">
                <i
                  class="driversum"
                  [ngClass]="{
                    'icon-package-variant-closed': driver.DriverAssignmentInvoicesCount > 0,
                    'icon-package-variant': driver.DriverAssignmentInvoicesCount <= 0
                  }"></i>
                <span class="driverfactor">{{ driver.DriverAssignmentInvoicesCount }}</span>
              </div>
            </div>
          </div>
          <div class="drivername">
            <i class="drivericon icon-person_outline-F"></i>
            <span>{{ driver.DisplayName }}</span>
          </div>
          <div class="driver-actions">
            <div
              class="driver-action"
              (click)="driverservice.InvoiceAssigned(driver)"
              *ngIf="driverservice.currentDriverFilter === driverservice.driverStatusShow.DriverIn"
              [class.active]="driverservice.hasSelectItem()">
              <i class="icon-how_to_reg-F"></i>
              <span>{{ "ClientApp.FrontOffice.DriverAssignment.Assignment" | translate }}</span>
            </div>
            <div
              class="driver-action"
              [class.active]="!driver.Freeze"
              *ngIf="
                driver.CurrentBranch?.DriverStatusCode === driverservice.driverStatus.In &&
                driverservice.currentDriverFilter === driverservice.driverStatusShow.DriverIn
              "
              (click)="driverservice.ChangeDriverStatus(driver, driverservice.personnelState.Out)">
              <i class="icon-account-arrow-right"></i>
              <span>{{ "ClientApp.FrontOffice.DriverAssignment.Exit" | translate }}</span>
            </div>
            <ng-container
              *ngIf="
                driverservice.currentDriverFilter === driverservice.driverStatusShow.DriverOut &&
                driver.CurrentBranch?.DriverStatusCode === driverservice.driverStatus.Out
              ">
              <div
                class="driver-action"
                [class.active]="!driver.Freeze"
                *ngIf="driverservice.currentDriverFilter === driverservice.driverStatusShow.DriverOut"
                (click)="driverservice.ReturnOfDelivery(driver)">
                <i class="icon-how_to_reg-F"></i>
                <span>{{ "ClientApp.FrontOffice.DriverAssignment.Return" | translate }}</span>
              </div>
            </ng-container>

            <div
              *ngIf="
                driverservice.currentDriverFilter === driverservice.driverStatusShow.DriverReadyToWork &&
                (driver.CurrentBranch?.DriverAttendanceStatusCode == driverservice.driverAttendanceStatus.Absent ||
                  driver.CurrentBranch?.DriverAttendanceStatusCode == null)
              "
              class="driver-action"
              [class.active]="!driver.Freeze"
              (click)="driverservice.ChangeDriverStatus(driver, driverservice.personnelState.Present)">
              <i class="icon-person-o"></i>
              <span>{{ "ClientApp.FrontOffice.DriverAssignment.Present" | translate }} </span>
            </div>
            <div
              *ngIf="
                driverservice.currentDriverFilter === driverservice.driverStatusShow.DriverReadyToWork &&
                driver.CurrentBranch?.DriverAttendanceStatusCode == driverservice.driverAttendanceStatus.Present
              "
              class="driver-action"
              [class.active]="!driver.Freeze"
              (click)="driverservice.ChangeDriverStatus(driver, driverservice.personnelState.Absent)">
              <i class="icon-account-off-outline"></i>
              <span>{{ "ClientApp.FrontOffice.DriverAssignment.Absent" | translate }}</span>
            </div>

            <ng-container *hasPermission="['RestaurantSale:DriverAssignment/ActiveBranch', 'Same']">
              <div
                *ngIf="!driver.IsActive && driverservice.currentDriverFilter === driverservice.driverStatusShow.All"
                class="driver-action"
                [class.active]="!driver.Freeze"
                (click)="driverservice.ChangeDriverStatus(driver, driverservice.personnelState.Active)">
                <i class="icon-person-o"></i>
                <span>{{ "ClientApp.FrontOffice.DriverAssignment.Active" | translate }}</span>
              </div>
            </ng-container>
            <ng-container *hasPermission="['RestaurantSale:DriverAssignment/ActiveBranch', 'Same']">
              <div
                *ngIf="driver.IsActive && driverservice.currentDriverFilter === driverservice.driverStatusShow.All"
                class="driver-action"
                [class.active]="!driver.Freeze"
                (click)="driverservice.ChangeDriverStatus(driver, driverservice.personnelState.Deactive)">
                <i class="icon-account-off-outline"></i>
                <span>{{ "ClientApp.FrontOffice.DriverAssignment.Deactive" | translate }}</span>
              </div>
            </ng-container>
            <div
              class="driver-cart-icon"
              [class]="
                driver?.CurrentBranch?.FleetStatus === 'SVC'
                  ? 'danger'
                  : driver?.CurrentBranch?.FleetStatus == 'ON' || driver?.CurrentBranch?.FleetStatus == 'IDL'
                  ? 'success'
                  : ''
              ">
              <i
                *ngIf="driver?.CurrentBranch?.VehicleId && driverservice.currentDriverFilter === driverservice.driverStatusShow.DriverIn"
                class="icon-electric_moped-F"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="driver-notification" *ngIf="driverservice.showNotification">
      <ng-container *ngIf="driverservice.notificationList.length; else elseShowNotification">
        <div class="driver-notification-drivers">
          <ng-container *ngFor="let notification of driverservice.notificationList; index as i">
            <div
              class="notification-driver"
              [class.active]="this.notificationIndex != null && i === this.notificationIndex"
              (click)="selectNotification(notification)">
              <div class="driver-icon">
                <ng-container *ngIf="notification.PersonnelImage && notification.PersonnelImage !== ''; else elseTemplate">
                  <img [src]="notification.PersonnelImage" alt="" />
                </ng-container>
                <ng-template #elseTemplate>
                  <i class="icon-sports_motorsports-F"></i>
                </ng-template>
              </div>
              <div class="driver-detail">
                <span [class.d-none]="!(notification.value | driverNotification)">{{ notification.value | driverNotification }}</span>
                <h5>{{ notification.PersonnelName ?? notification.PersonnelId }}</h5>
                <p>{{ notification.value[notification.value?.length - 1]?.Description }}</p>
              </div>
            </div>
          </ng-container>
        </div>
        <div class="driver-notification-messages">
          <ng-container *ngIf="notificationIndex != null">
            <ng-container *ngFor="let notification of driverservice.notificationList[notificationIndex]?.value; trackBy: notificationTrackBy">
              <div class="notification-box">
                <div class="notification-message" [class.active]="notification.NotificationState !== ExternalNotificationStateKindEnum.Seen">
                  <div class="d-flex justify-content-between align-items-center">
                    <small>
                      {{ "ClientApp.FrontOffice.DriverAssignment.SendTime" | translate }}:
                      <time>{{ notification?.CreatedDate | date : "HH:mm" }}</time>
                    </small>
                    <ng-container *ngIf="notification?.NotificationState === ExternalNotificationStateKindEnum.Seen; else elseSeen">
                      <div class="d-flex justuify-content-between align-items-center">
                        <time>{{ notification?.SeenTime | date : "HH:mm" }}</time>
                        <i class="icon-done_all-o mr-2"></i>
                      </div>
                    </ng-container>
                    <ng-template #elseSeen>
                      <span></span>
                    </ng-template>
                  </div>
                  <p>{{ notification.Description }}</p>
                </div>
              </div>
            </ng-container>
          </ng-container>
          <div #scrollTarget></div>
        </div>
      </ng-container>
      <ng-template #elseShowNotification>
        <div class="not-found">
          <span> {{ "ClientApp.FrontOffice.DriverAssignment.NoMessageFound" | translate }} </span>
        </div>
      </ng-template>
    </div>
  </div>
  <div class="fleet-map" *ngIf="driverservice.showFleetMap">
    <iframe
      name="frame"
      class="map-frame"
      frameborder="0"
      [title]="'ClientApp.FrontOffice.DriverAssignment.MapOfCourierFleet' | translate"
      allowfullscreen>
    </iframe>
    <form ngNoForm [formGroup]="mapForm" action="https://safir.sirgroup.ir/adminMap/SafirAdmin.aspx" target="frame" method="POST">
      <input formControlName="SystemCode" name="SystemCode" [hidden]="true" />
      <input formControlName="BranchCode" name="BranchCode" [hidden]="true" />
      <input formControlName="BranchLat" name="BranchLat" [hidden]="true" />
      <input formControlName="BranchLng" name="BranchLng" [hidden]="true" />
      <input formControlName="BranchDes" name="BranchDes" [hidden]="true" />
      <input formControlName="Token" name="Token" [hidden]="true" />
      <button type="submit" class="submit" onclick="submit()" [disabled]="!mapForm.valid" [hidden]="true"></button>
    </form>
  </div>
</div>
